import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyWorkspaces = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 234,
	height: 234,
	viewBox: "0 0 234 234",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_3212_82256)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M208.998 224.437C217.812 225.059 225 217.837 225 209V17C225 8.16345 217.837 1 209 1H17C8.16345 1 0.940603 8.18761 1.56283 17.0022C9.39439 127.946 98.0248 216.605 208.998 224.437Z",
				fill: "#FFF2E8"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M208.963 224.936C218.089 225.58 225.5 218.103 225.5 209V17C225.5 7.88731 218.113 0.5 209 0.5H17C7.89686 0.5 0.419811 7.91069 1.06407 17.0374C8.91316 128.23 97.7412 217.086 208.963 224.936Z",
				stroke: "black"
			})]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 124.486,
			y: 101.513,
			width: 100.513,
			height: 100.513,
			fill: "#171718"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_3212_82256",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 1,
			y: 1,
			width: 224,
			height: 224,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M208.998 224.437C217.812 225.059 225 217.837 225 209V17C225 8.16345 217.837 1 209 1H17C8.16345 1 0.940603 8.18761 1.56283 17.0022C9.39439 127.946 98.0248 216.605 208.998 224.437Z",
				fill: "#C7DAFF"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_3212_82256)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 23.4746,
					y: 101.013,
					width: 101.513,
					height: 101.513,
					fill: "#FFE6D9",
					stroke: "#2E2E2E"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M174.743 1.00043L124.486 1.00043L124.486 51.2568C152.238 51.2568 174.743 28.7606 174.743 1.00043Z",
					fill: "#FFE6D9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M225 51.2564V1L174.743 1C174.743 28.7518 197.239 51.2564 225 51.2564Z",
					fill: "#FFE6D9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M124.487 51.2563L124.487 101.513L174.743 101.513C174.743 73.7609 152.247 51.2563 124.487 51.2563Z",
					fill: "#FFE6D9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M174.743 101.513L224.999 101.513L224.999 51.2568C197.247 51.2568 174.743 73.753 174.743 101.513Z",
					fill: "#FFE6D9"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M224.999 51.2564C197.239 51.2564 174.743 28.7518 174.743 1C174.743 28.7602 152.238 51.2564 124.486 51.2564C152.247 51.2564 174.743 73.761 174.743 101.513C174.743 73.7526 197.247 51.2564 224.999 51.2564Z",
					fill: "#5599FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M142.185 174.796C142.089 175.008 142.038 175.239 142.037 175.472C142.037 178.769 147.444 184.11 150.675 184.11C150.908 184.109 151.139 184.058 151.351 183.962L163.039 178.752C159.836 176.829 156.884 174.514 154.252 171.862C151.626 169.232 149.329 166.292 147.411 163.108L142.185 174.796Z",
					fill: "#C7DAFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M153.807 148.637L149.108 159.22C151.036 163.041 153.575 166.521 156.625 169.523C159.608 172.596 163.092 175.138 166.928 177.04L177.726 172.243C172.31 170.024 167.402 166.726 163.302 162.55C159.257 158.577 156.032 153.851 153.807 148.637Z",
					fill: "#C7DAFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M161.573 132.036C161.077 132.494 160.688 133.057 160.436 133.684L155.771 144.218C157.678 150.282 161.079 155.769 165.661 160.175C170.194 164.899 175.874 168.369 182.146 170.247L192.399 165.664C193.025 165.41 193.588 165.021 194.048 164.527C197.444 159.582 183.729 145.57 182.097 143.938C180.465 142.306 166.502 128.656 161.573 132.036ZM191.41 162.532C189.614 162.532 183.168 158.988 175.173 150.993C167.178 142.998 163.634 136.553 163.634 134.756C165.414 134.756 171.876 138.316 179.838 146.295C187.8 154.274 191.41 160.752 191.41 162.532Z",
					fill: "#C7DAFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M178.648 131.178C181.252 128.573 181.467 126.991 181.467 125.342C181.467 124.386 181.467 123.694 183.313 121.848C183.62 121.539 183.792 121.121 183.792 120.685C183.792 120.25 183.62 119.832 183.313 119.523C183.004 119.216 182.586 119.044 182.151 119.044C181.715 119.044 181.298 119.216 180.989 119.523C178.384 122.111 178.17 123.694 178.17 125.342C178.17 126.299 178.17 126.991 176.324 128.837C176.169 128.99 176.046 129.173 175.963 129.374C175.879 129.574 175.836 129.79 175.836 130.008C175.836 130.225 175.879 130.441 175.963 130.642C176.046 130.842 176.169 131.025 176.324 131.178C176.632 131.485 177.05 131.657 177.486 131.657C177.921 131.657 178.339 131.485 178.648 131.178Z",
					fill: "#C7DAFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M204.251 142.832C202.405 144.678 201.712 144.678 200.756 144.678C199.108 144.678 197.459 144.892 194.921 147.497C194.614 147.806 194.441 148.224 194.441 148.659C194.441 149.095 194.614 149.513 194.921 149.821C195.074 149.976 195.256 150.099 195.457 150.182C195.658 150.266 195.874 150.309 196.091 150.309C196.309 150.309 196.524 150.266 196.725 150.182C196.926 150.099 197.108 149.976 197.262 149.821C199.108 147.975 199.8 147.975 200.756 147.975C202.405 147.975 204.053 147.761 206.575 145.156C206.882 144.847 207.055 144.43 207.055 143.994C207.055 143.559 206.882 143.141 206.575 142.832C206.267 142.525 205.849 142.353 205.413 142.353C204.978 142.353 204.56 142.525 204.251 142.832Z",
					fill: "#C7DAFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M184.469 136.998C188.507 132.959 189.249 131.426 189.909 130.091C190.588 128.719 191.542 127.502 192.711 126.514C192.866 126.36 192.988 126.178 193.072 125.977C193.156 125.776 193.199 125.561 193.199 125.343C193.199 125.126 193.156 124.91 193.072 124.709C192.988 124.508 192.866 124.326 192.711 124.173C192.402 123.866 191.984 123.693 191.549 123.693C191.113 123.693 190.696 123.866 190.387 124.173C189.009 125.434 187.889 126.951 187.09 128.64C186.546 129.761 185.936 131.014 182.293 134.673C182.07 134.792 181.877 134.961 181.729 135.167C181.582 135.372 181.483 135.609 181.442 135.859C181.401 136.108 181.417 136.364 181.491 136.606C181.564 136.848 181.692 137.07 181.865 137.255C182.038 137.439 182.251 137.582 182.488 137.671C182.724 137.76 182.978 137.793 183.23 137.769C183.482 137.744 183.725 137.661 183.939 137.528C184.154 137.394 184.335 137.213 184.469 136.998Z",
					fill: "#C7DAFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M199.633 133.436C198.629 134.605 197.394 135.553 196.007 136.222C194.671 136.882 193.138 137.623 189.1 141.662C188.927 141.81 188.787 141.992 188.688 142.196C188.589 142.401 188.533 142.623 188.525 142.851C188.516 143.078 188.554 143.304 188.637 143.515C188.72 143.727 188.846 143.919 189.006 144.08C189.167 144.24 189.359 144.366 189.571 144.449C189.782 144.532 190.009 144.57 190.236 144.561C190.463 144.553 190.685 144.497 190.89 144.398C191.094 144.299 191.276 144.159 191.424 143.986C195.084 140.343 196.369 139.733 197.457 139.189C199.146 138.39 200.663 137.27 201.925 135.892C202.232 135.584 202.404 135.166 202.404 134.73C202.404 134.295 202.232 133.877 201.925 133.568C201.635 133.253 201.233 133.062 200.806 133.038C200.378 133.013 199.958 133.156 199.633 133.436Z",
					fill: "#C7DAFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.9755 101.513L23.9755 202.025L124.488 202.025C124.488 146.522 79.4959 101.513 23.9755 101.513Z",
					fill: "#FFB066"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M262.334 1H161.821C217.342 1 262.334 46.0093 262.334 101.513V1Z",
					fill: "#FFE6D9"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 124.486,
					y: 202.025,
					width: 100.513,
					height: 100.513,
					fill: "#5599FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 23.9746,
					y: 1,
					width: 100.513,
					height: 100.513,
					fill: "#171718"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: -76.5391,
					y: 1,
					width: 100.513,
					height: 100.513,
					fill: "#5599FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M52.8365 17.7008C51.342 18.7955 51.0179 20.8946 52.1127 22.3891L66.6486 42.2328L66.6481 42.2332L66.6481 42.2332C66.8914 42.5653 66.8194 43.0318 66.4873 43.2751C66.1551 43.5184 65.6887 43.4463 65.4454 43.1142L55.9746 30.1851L55.9752 30.1847L52.6726 25.6761C51.5778 24.1816 49.4787 23.8575 47.9842 24.9523C46.4897 26.0471 46.1656 28.1461 47.2604 29.6407L60.0338 47.0783L60.0337 47.0783L60.0339 47.0785C60.2772 47.4106 60.2052 47.8771 59.8731 48.1204C59.5409 48.3637 59.0745 48.2917 58.8312 47.9595L58.831 47.9593L58.8309 47.9594L50.0217 35.9335C48.9269 34.439 46.8279 34.1149 45.3334 35.2097C43.8388 36.3045 43.5148 38.4035 44.6095 39.8981L53.4188 51.9239L53.4176 51.9248L55.0932 54.2122C55.1453 54.2833 55.1977 54.354 55.2504 54.4244L57.1639 57.0366L57.3674 56.8875C61.5939 61.1822 67.1682 63.6073 72.91 63.9806L71.6852 64.8778L80.9142 77.4767C82.8724 80.1499 86.6269 80.7295 89.3001 78.7714L98.2614 72.207C100.935 70.2488 101.514 66.4943 99.5561 63.8211L93.8576 56.0417C97.3882 51.8038 97.7284 45.5567 94.3217 40.9061L94.2879 40.8601L90.3573 35.4942L90.358 35.4937L82.4289 24.6693C79.4401 26.8587 78.7918 31.0564 80.9808 34.0454L80.9801 34.0459L82.4336 36.0302C82.4331 36.0303 82.4326 36.0304 82.432 36.0305L86.4848 41.563C86.728 41.8952 86.656 42.3616 86.3239 42.6049C85.9918 42.8482 85.5253 42.7762 85.282 42.4441L75.8112 29.515L75.8132 29.5135L65.903 15.9845C64.8082 14.49 62.7091 14.1659 61.2146 15.2607C59.7201 16.3555 59.396 18.4545 60.4908 19.949L73.2642 37.3867L73.2637 37.3871L73.2643 37.3879C73.5076 37.72 73.4356 38.1865 73.1034 38.4298C72.7713 38.673 72.3049 38.601 72.0616 38.2689L72.061 38.2681L72.0608 38.2683L57.5248 18.4246C56.4301 16.93 54.331 16.606 52.8365 17.7008Z",
					fill: "#C7DAFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M81.4106 12.4865C81.4106 12.9173 81.6978 13.2045 82.1285 13.2045C84.8567 13.2045 87.3696 14.2814 89.308 16.148C91.1747 18.0865 92.2516 20.5993 92.2516 23.3275C92.2516 23.6865 92.5388 24.0455 92.9696 24.0455C93.4003 24.0455 93.6875 23.7583 93.6875 23.3275C93.6875 20.3121 92.467 17.3686 90.3131 15.1429C88.1593 12.9891 85.2157 11.7686 82.1285 11.7686C81.7696 11.7686 81.4106 12.1275 81.4106 12.4865Z",
					fill: "#C7DAFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M90.0264 23.3271C90.0264 21.2451 89.2366 19.2348 87.7289 17.7271C86.2212 16.2194 84.2828 15.4297 82.1289 15.4297C81.6982 15.4297 81.411 15.7169 81.411 16.1476C81.411 16.5784 81.6982 16.8656 82.1289 16.8656C83.852 16.8656 85.5033 17.5117 86.7238 18.7323C87.9443 19.9528 88.5905 21.604 88.5905 23.2553C88.5905 23.6861 88.8776 23.9733 89.3084 23.9733C89.7392 24.0451 90.0264 23.7579 90.0264 23.3271Z",
					fill: "#C7DAFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M59.768 76.4254C59.8795 76.0093 59.6765 75.6576 59.2604 75.5461C56.6251 74.84 54.4767 73.1494 53.0874 70.8446C51.786 68.4891 51.3962 65.7832 52.1023 63.1479C52.1952 62.8012 52.0107 62.3801 51.5946 62.2686C51.1785 62.1571 50.8268 62.3602 50.7153 62.7763C49.9349 65.6889 50.3519 68.8481 51.8564 71.5554C53.3794 74.1933 55.9068 76.1341 58.8887 76.9331C59.2355 77.026 59.6751 76.7722 59.768 76.4254Z",
					fill: "#C7DAFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M54.252 63.7242C53.7131 65.7353 53.9557 67.8815 55.0218 69.728C56.0879 71.5745 57.7559 72.8391 59.8363 73.3965C60.2524 73.508 60.6042 73.305 60.7156 72.8889C60.8271 72.4728 60.6241 72.1211 60.208 72.0096C58.5436 71.5636 57.1158 70.5121 56.2528 69.0173C55.3898 67.5225 55.193 65.7602 55.6204 64.1652C55.7319 63.7491 55.5288 63.3974 55.1127 63.2859C54.7152 63.105 54.3635 63.3081 54.252 63.7242Z",
					fill: "#C7DAFF"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_3212_82256",
			x: .525391,
			y: 0,
			width: 233.475,
			height: 233.475,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 8,
					dy: 8
				}),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_3212_82256"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_3212_82256",
					result: "shape"
				})
			]
		}) })
	]
});
export { SvgEmptyWorkspaces as ReactComponent };
